export default "__VITE_ASSET__DkzRLvdy__"